import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import { AppRoutes } from '@/app/routes';
import { AppAuthProvider } from '@/features/auth/AppAuthProvider';

export function App() {
  // `index.html` ships `lang="en"` as a fast, build-time default; this keeps
  // it in sync with the active UI language, including live switches.
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <AppAuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppAuthProvider>
  );
}
